import { Injectable } from '@angular/core';
import { IFormMasterBuilder, IFormFieldErrorMessages } from 'i2g-ng-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailService } from 'i2g-ng-utils';

@Injectable()
export class EmailSignupBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    EMAIL_ADDRESS: 'email_address',
    PASSWORD: 'password',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _emailService: EmailService
  ) {}

  buildForm(): FormGroup {
    const formKeys = this.FORM_KEYS;

    return this._formBuilder.group({
      [formKeys.EMAIL_ADDRESS]: [
        '',
        [
          Validators.required,
          Validators.maxLength(250),
          this._emailService.emailValidatorFn(),
        ],
      ],
      [formKeys.PASSWORD]: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(250),
        ],
      ],
    });
  }

  buildPasswordMinLengthErrorMessages(): IFormFieldErrorMessages {
    return {
      min: {
        message: 'FORM.PASSWORD.MIN_LENGTH_ERROR',
      },
    };
  }
}
